import Link from 'next/link';
import Text from '@common/text';
import CloseButton from '@common/closeButton';
import Icon from '@components/common/assets';
import Accordion from '@components/_atoms/Accordion';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';
import { RouteUrl, V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const accordionItems = [
  {
    title: (
      <div className={cx('titleWrap')}>
        <Text fontStyle={FontStyle.H5_M} color={Colors.C_JOBDA_BLACK}>
          Q.
        </Text>
        <Text fontStyle={FontStyle.B2_M} color={Colors.C_JOBDA_BLACK}>
          개인정보(이메일, 휴대폰 번호 등)를 변경하고 싶어요.
        </Text>
      </div>
    ),
    content: (
      <>
        <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_70}>
          이메일, 휴대폰 번호 등의 개인정보를 바꾸고 싶다면,{' '}
          <Link href={RouteUrl.PROFILE} className={cx('link')}>
            내 프로필
          </Link>
          에서 변경할 수 있어요.
        </Text>
      </>
    ),
  },
  {
    title: (
      <div className={cx('titleWrap')}>
        <Text fontStyle={FontStyle.H5_M} color={Colors.C_JOBDA_BLACK}>
          Q.
        </Text>
        <Text fontStyle={FontStyle.B2_M} color={Colors.C_JOBDA_BLACK}>
          역량검사 결과를 삭제하고 싶어요.
        </Text>
      </div>
    ),
    content: (
      <>
        <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_70}>
          역량검사 결과를 삭제하고 싶다면 고객 문의 메일(
          <a href={`mailto:${JOBDA_SUPPORT_EMAIL}`} className={cx('link')}>
            {JOBDA_SUPPORT_EMAIL}
          </a>
          )을 통해 도와드릴게요.
        </Text>
      </>
    ),
  },
  {
    title: (
      <div className={cx('titleWrap')}>
        <Text fontStyle={FontStyle.H5_M} color={Colors.C_JOBDA_BLACK}>
          Q.
        </Text>
        <Text fontStyle={FontStyle.B2_M} color={Colors.C_JOBDA_BLACK}>
          역량검사 응시 횟수를 초기화하고 싶어요.
        </Text>
      </div>
    ),
    content: (
      <>
        <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_70}>
          역량검사 응시 횟수는 한 달에 5회 제공되며, 매월 1일에 초기화돼요. 계정을 삭제하시더라도,
          <br />
          서비스 부정 참여 방지를 위해 본인인증 정보 및 역량검사 응시 횟수는 90일간 보관하고 있어요. 따라서 90일 안에
          재가입하실 경우, 계정 삭제 이전의 역량검사 응시 횟수가 유지돼요.
        </Text>
      </>
    ),
  },
  {
    title: (
      <div className={cx('titleWrap')}>
        <Text fontStyle={FontStyle.H5_M} color={Colors.C_JOBDA_BLACK}>
          Q.
        </Text>
        <Text fontStyle={FontStyle.B2_M} color={Colors.C_JOBDA_BLACK}>
          알림이 너무 자주 와요.
        </Text>
      </div>
    ),
    content: (
      <>
        <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_70}>
          채용 제안 알림을 받고 싶지 않다면,{' '}
          <Link href={V2RouteUrl.MATCH_APPLY} className={cx('link')}>
            잡다 매칭
          </Link>
          의 제안 받기 알림 설정을 변경해주세요.
          <br />
          SMS, 이메일 알림을 받고 싶지 않다면,{' '}
          <Link href={RouteUrl.MY_PAGE_NOTICE} className={cx('link')}>
            알림 관리
          </Link>
          에서 변경하실 수 있어요.
        </Text>
      </>
    ),
  },
];

interface Step1Props {
  onContinue: () => void;
  onClose: () => void;
}

const Index = ({ onClose, onContinue }: Step1Props) => {
  return (
    <div className={cx('modalArea')}>
      <div className={cx('textArea')}>
        <Text fontStyle={FontStyle.H4_B} color={Colors.C_JOBDA_BLACK}>
          잡다와{' '}
          <Text element={'span'} fontStyle={FontStyle.H4_B} color={Colors.C_GREEN_200}>
            함께 하는 취업 여정
          </Text>
          을 정말 끝내시겠어요?
        </Text>

        <div className={cx('confirmArea')}>
          <Icon name="errorLightFilled" width={40} height={40} fill={Colors.C_ERROR} />
          <Text element={'span'} fontStyle={FontStyle.B1_B} color={Colors.C_COOL_GRAY_90}>
            잠깐! 혹시 떠나시는 이유가 아래에 있나요?
          </Text>
        </div>
      </div>

      <div className={cx('accordionArea')}>
        {accordionItems.map((item, index) => (
          <Accordion key={index}>
            {(accordions) => {
              const visible = accordions[`${index}`]?.visible;
              return (
                <div className={cx('accordionItem')}>
                  <Accordion.Header className={cx('titleArea')} id={`${index}`}>
                    {item.title}
                    {visible ? (
                      <Icon name="arrowTopLight" width={40} height={40} />
                    ) : (
                      <Icon name="arrowBottomLight" width={40} height={40} />
                    )}
                  </Accordion.Header>
                  <Accordion.Content className={cx('contentArea')} id={`${index}`}>
                    {item.content}
                  </Accordion.Content>
                </div>
              );
            }}
          </Accordion>
        ))}
      </div>

      <button className={cx('btnConfirm')} type="button" onClick={onContinue}>
        계속
      </button>
      <CloseButton className={cx('btnClose')} onClick={onClose} />
    </div>
  );
};

export default Index;
